import type { JSX } from "react";

import InventarioSection from "./sections/InventarioSection";
import ComprasSection from "./sections/ComprasSection";
import ProveedoresSection from "./sections/ProveedoresSection";
import { ACTIVOS_BASE } from "./paths";

// ---------------------------------------------------------------------------
// Navegación de la app «Activos» (épica común CC-CONSOLE ↔ WAYAK, #1638).
// Archivo común, idéntico en los dos forks. Alimenta el sub-menú
// (ActivosLayout) y las rutas (routes.tsx). Cada id es el de su menú del
// catálogo (`menu:activos.<id>`, v26); el detalle de un activo cuelga de
// Inventario (`/activos/inventario/:assetId`) y lo gobierna el mismo menú.
// ---------------------------------------------------------------------------

export interface ActivosNavItem {
  id: "inventario" | "compras" | "proveedores";
  labelKey: string;
  icon: string;
  element: JSX.Element;
}

export const MENU: ActivosNavItem[] = [
  { id: "inventario", labelKey: "menu.inventario", icon: "ri-stack-line", element: <InventarioSection /> },
  { id: "compras", labelKey: "menu.compras", icon: "ri-file-list-3-line", element: <ComprasSection /> },
  { id: "proveedores", labelKey: "menu.proveedores", icon: "ri-store-2-line", element: <ProveedoresSection /> },
];

export const activosDefaultRoute = `${ACTIVOS_BASE}/${MENU[0].id}`;
